import React from 'react';

function BottomSheetLoading() {
  return (
    <div className="bottom_sheet">
      <div className="bottom_sheet_header">
        <div
          className="bottom_sheet_title skeleton"
          style={{height: 28, width: '60%'}}
        />
      </div>
      <div className="bottom_sheet_inner">
        <div
          className="bottom_sheet_contents skeleton"
          style={{height: 128}}
        />
        <div
          className="bottom_sheet_contents skeleton"
          style={{height: 56, margin: '24px auto'}}
        />
        <div className="bottom_sheet_footer bottom_sheet_footer_complex">
          <div className="btn btn_large  skeleton" />
          <div className="btn btn_large  skeleton" />
        </div>
      </div>
    </div>
  );
}

export default BottomSheetLoading;
